import React, { useState, useEffect } from "react";
import { Loader2, Check, AlertCircle } from "lucide-react";
import "./ArticleGroupModal.scss";
import { errorAlert } from "../../Components/Alerts";
import TextField from "@mui/material/TextField";

export default function ArticleGroupModal({
  isOpen,
  onClose,
  onSave,
  initialData,
}) {
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showUnsavedAlert, setShowUnsavedAlert] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setName(initialData.GroupName);
        setIsActive(initialData.IsActive);
      } else {
        setName("");
        setIsActive(true);
      }
      setIsDirty(false);
    }
  }, [isOpen, initialData]);

  const handleNameChange = (e) => {
    setName(e.target.value);
    setIsDirty(true);
  };

  const handleActiveChange = () => {
    setIsActive((prev) => !prev);
    setIsDirty(true);
  };

  const handleCloseAttempt = () => {
    if (isDirty) setShowUnsavedAlert(true);
    else onClose();
  };

  const handleConfirmClose = () => {
    setShowUnsavedAlert(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    setIsSubmitting(true);

    try {
      const payload = {
        GroupName: name.trim(),
        IsActive: isActive,
        ...(initialData?.GroupID && { GroupID: initialData.GroupID }),
      };

      onSave(payload);
      setIsDirty(false);
      onClose();
    } catch (err) {
      errorAlert("Dështoi ruajtja e grupit të artikujve");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="ArticleGroup__overlay">
      <div className="ArticleGroup__container">
        <div className="ArticleGroup__header">
          <h2 className="ArticleGroup__title">
            {initialData ? "Edito grupin" : "Grup i ri"}
          </h2>
          <p className="ArticleGroup__description">
            {initialData
              ? "Përditëso detajet e grupit të artikullit, më poshtë."
              : "Plotëso detajet për të krijuar një grup të ri."}
          </p>
        </div>

        <form className="ArticleGroup__form" onSubmit={handleSubmit}>
          <div className="ArticleGroup__form-group">
            <TextField
              id="name"
              label="Emërtimi grupit *"
              variant="filled"
              value={name}
              onChange={handleNameChange}
              placeholder="e.g. Të ndryshme"
              autoFocus
              fullWidth
              error={!name.trim() && isDirty}
              helperText={
                !name.trim() && isDirty ? (
                  <span className="ArticleGroup__error-text">
                    <AlertCircle className="ArticleGroup__error-icon" />
                    Plotesoni emertimin
                  </span>
                ) : null
              }
            />
          </div>

          <div
            className="ArticleGroup__form-group ArticleGroup__checkbox-group"
            onClick={handleActiveChange}
          >
            <div
              className={`ArticleGroup__checkbox ${
                isActive ? "checked" : ""
              }`}
            >
              {isActive && <Check className="ArticleGroup__check-icon" />}
            </div>

            <div className="ArticleGroup__checkbox-labels">
              <label className="ArticleGroup__checkbox-label">
                Statusi Aktiv
              </label>
              <p className="ArticleGroup__checkbox-description">
                Aktivizo ose çaktivizo këtë grup në sistem.
              </p>
            </div>
          </div>

          <div className="ArticleGroup__footer">
            <button
              type="button"
              onClick={handleCloseAttempt}
              className="ArticleGroup__btn ArticleGroup__btn--outline"
            >
              Mbyll
            </button>

            <button
              type="submit"
              disabled={!name.trim() || isSubmitting}
              className="ArticleGroup__btn ArticleGroup__btn--primary"
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="ArticleGroup__loader" />
                  Duke u ruajtur...
                </>
              ) : (
                "Ruaj Grupin"
              )}
            </button>
          </div>
        </form>

        {showUnsavedAlert && (
          <div className="ArticleGroup__alert-overlay">
            <div className="ArticleGroup__alert">
              <h3 className="ArticleGroup__alert-title">Njoftim</h3>
              <p className="ArticleGroup__alert-description">
                Disa ndryshime nuk janë ruajtur. Nëse e mbyllni formularin, ato
                do të humbasin.
              </p>

              <div className="ArticleGroup__alert-footer">
                <button
                  onClick={() => setShowUnsavedAlert(false)}
                  className="ArticleGroup__btn ArticleGroup__btn--outline"
                >
                  Vazhdo editimin
                </button>

                <button
                  onClick={handleConfirmClose}
                  className="ArticleGroup__btn ArticleGroup__btn--danger"
                >
                  Fshij & mbyll formën
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// import React, { useState, useEffect } from "react";
// import { Loader2, Check, AlertCircle } from "lucide-react"; // përdor Check për checkbox
// import "./ArticleGroupModal.scss";
// import { errorAlert } from "../../Components/Alerts";
// import TextField from "@mui/material/TextField";
// // import UnitModal from "../UnitCRUD/UnitModal";
// // import { createUnit } from "../UnitCRUD/UnitService";
// // import { AlertCircle } from "lucide-react";

// export default function ArticleGroupModal({
//   isOpen,
//   onClose,
//   onSave,
//   initialData,
// }) {
//   const [name, setName] = useState("");
//   const [isActive, setIsActive] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showUnsavedAlert, setShowUnsavedAlert] = useState(false);
//   const [isDirty, setIsDirty] = useState(false);

//   // const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);

//   // const openNewUnitModal = () => {
//   //   setIsUnitModalOpen(true);
//   // };

//   // const handleSaveUnit = async (data) => {
//   //   await createUnit(data);
//   // };

//   useEffect(() => {
//     if (isOpen) {
//       if (initialData) {
//         setName(initialData.GroupName);
//         setIsActive(initialData.IsActive);
//       } else {
//         setName("");
//         setIsActive(true);
//       }
//       setIsDirty(false);
//     }
//   }, [isOpen, initialData]);

//   const handleNameChange = (e) => {
//     setName(e.target.value);
//     setIsDirty(true);
//   };

//   const handleActiveChange = () => {
//     setIsActive((prev) => !prev);
//     setIsDirty(true);
//   };

//   const handleCloseAttempt = () => {
//     if (isDirty) setShowUnsavedAlert(true);
//     else onClose();
//   };

//   const handleConfirmClose = () => {
//     setShowUnsavedAlert(false);
//     onClose();
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!name.trim()) return;

//     setIsSubmitting(true);

//     try {
//       // Për update, përfshij UnitID nga initialData
//       const payload = {
//         GroupName: name.trim(),
//         IsActive: isActive,
//         ...(initialData?.GroupID && { GroupID: initialData.GroupID }), // <--- kjo
//       };

//       // await onSave(payload);
//       onSave(payload);

//       setIsDirty(false);
//       onClose();
//     } catch (err) {
//       errorAlert("Dështoi ruajtja e grupit të artikujve");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay">
//       <div className="modal-container">
//         <div className="modal-header">
//           <h2 className="modal-title">
//             {initialData ? "Edito grupin" : "Grup i ri"}
//           </h2>
//           <p className="modal-description">
//             {initialData
//               ? "Përditëso detajet e grupit të artikullit, më poshtë."
//               : "Plotëso detajet për të krijuar një grup të ri."}
//           </p>
//         </div>

//         <form className="modal-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <TextField
//               id="name"
//               label="Emërtimi grupit *"
//               variant="filled"
//               value={name}
//               onChange={handleNameChange}
//               placeholder="e.g. Të ndryshme"
//               autoFocus
//               fullWidth
//               error={!name.trim() && isDirty} // aktivizon gjendjen e gabimit
//               helperText={
//                 !name.trim() && isDirty ? (
//                   <span
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "4px",
//                     }}
//                   >
//                     <AlertCircle className="error-icon" /> Plotesoni emertimin
//                   </span>
//                 ) : null
//               }
//             />

//             {/* <label htmlFor="name" className="form-label">
//               Emertimi njësisë <span className="required">*</span>
//             </label>
//             <input
//               id="name"
//               type="text"
//               value={name}
//               onChange={handleNameChange}
//               placeholder="e.g. Kilogram"
//               autoFocus
//               className="form-input"
//             />
//             {!name.trim() && isDirty && (
//               <p className="form-error">
//                 <AlertCircle className="error-icon" /> Plotesoni emertimin
//               </p>
//             )} */}
//           </div>

//           <div
//             className="form-group checkbox-group"
//             onClick={handleActiveChange}
//           >
//             <div
//               className={`form-checkbox-wrapper ${isActive ? "checked" : ""}`}
//             >
//               {isActive && <Check className="check-icon" />}
//             </div>
//             <div className="checkbox-labels">
//               <label htmlFor="isActive" className="checkbox-label">
//                 Statusi Aktiv
//               </label>
//               <p className="checkbox-description">
//                 Aktivizo ose çaktivizo këtë grup në sistem.
//               </p>
//             </div>
//           </div>

//           <div className="modal-footer">
//             <button
//               type="button"
//               onClick={handleCloseAttempt}
//               className="btn btn-outline"
//             >
//               Mbyll
//             </button>
//             <button
//               type="submit"
//               disabled={!name.trim() || isSubmitting}
//               className="btn btn-primary"
//             >
//               {isSubmitting ? (
//                 <>
//                   <Loader2 className="loader" /> Duke u ruajtur...
//                 </>
//               ) : (
//                 "Ruaj Grupin"
//               )}
//             </button>

//             {/* <button onClick={openNewUnitModal}>+ Shto njësi</button> */}
//           </div>
//         </form>

//         {/* <UnitModal
//           isOpen={isUnitModalOpen}
//           onClose={() => setIsUnitModalOpen(false)}
//           onSave={handleSaveUnit}
//           // initialData={editingUnit}
//         /> */}

//         {showUnsavedAlert && (
//           <div className="alert-dialog">
//             <div className="alert-content">
//               <h3 className="alert-title">Njoftim</h3>
//               <p className="alert-description">
//                 Disa ndryshime nuk janë ruajtur. Nëse e mbyllni formularin, ato
//                 do të humbasin.
//               </p>
//               <div className="alert-footer">
//                 <button
//                   onClick={() => setShowUnsavedAlert(false)}
//                   className="btn btn-outline"
//                 >
//                   Vazhdo editimin
//                 </button>
//                 <button onClick={handleConfirmClose} className="btn btn-danger">
//                   Fshij & mbyll formën
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
